import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, api, get } from "../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import { validateTable } from "../../../utils/validateTable";
import { restructureData } from "../../../utils/restructureData";
import DynamicTable27 from "./DynamicTable27";
import SectionHeading from "../GRI300/GRI308/SectionHeading";
import CustomTextField from "../GRI300/GRI308/CustomTextField";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const Economic27 = ({ hide, downloadMode = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",    
    severity: "",
  });
  const [formData, setFormData] = useState({
    dataCompilationMethodology: {
      employeeFiguresReporting: "",
      employeeDataTimeframe: "",
    },

    employeeDataContextualInfo: "",
    employeeFluctuations: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const inputData = [
    {
      fieldName: "organizationBreakDown",
      // title: "2. If there are any significant social or environmental concerns and/or risks arising from production or disposal of your products / services, as identified in the Life Cycle Perspective / Assessments (LCA) or through any other means, briefly describe the same along-with action taken to mitigate the same.",
      fields: [
        {
          fieldName: "region",
          title: "Region",
          type: "text",
          placeholder: "Enter text",
        },
        {
          fieldName: "maleEmployees",
          title: "Male",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "femaleEmployees",
          title: "Female",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "other",
          title: "Other",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "notDisclosed",
          title: "Not Disclosed",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "totalEmployees",
          title: "Total No. of  Employees",
          type: "number",
          placeholder: "Total",
        },
      ],
    },
  ];

  const inputData1 = [
    {
      fieldName: "permanentEmployee",
      fields: [
        {
          fieldName: "region",
          title: "Region",
          type: "text",
          placeholder: "Enter text",
        },
        {
          fieldName: "maleEmployees",
          title: "Male",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "femaleEmployees",
          title: "Female",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "other",
          title: "Other",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "notDisclosed",
          title: "Not Disclosed",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "totalEmployees",
          title: "Total No. of Permanent Employees",
          type: "number",
          placeholder: "Total",
        },
      ],
    },
  ];

  const inputData2 = [
    {
      fieldName: "temporaryEmployee",
      fields: [
        {
          fieldName: "region",
          title: "Region",
          type: "text",
          placeholder: "Enter text",
        },
        {
          fieldName: "maleEmployees",
          title: "Male",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "femaleEmployees",
          title: "Female",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "other",
          title: "Other",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "notDisclosed",
          title: "Not Disclosed",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "totalEmployees",
          title: " Total No. of Temporary Employees",
          type: "number",
          placeholder: "Total",
        },
      ],
    },
  ];

  const inputData3 = [
    {
      fieldName: "nonGuaranteedHours",
      fields: [
        {
          fieldName: "region",
          title: "Region",
          type: "text",
          placeholder: "Enter text",
        },
        {
          fieldName: "maleEmployees",
          title: "Male",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "femaleEmployees",
          title: "Female",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "other",
          title: "Other",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "notDisclosed",
          title: "Not Disclosed",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "totalEmployees",
          title: "Total Number of non-guaranteed hours Employees",
          type: "number",
          placeholder: "Total",
        },
      ],
    },
  ];

  const inputData4 = [
    {
      fieldName: "fullTimeEmployee",
      fields: [
        {
          fieldName: "region",
          title: "Region",
          type: "text",
          placeholder: "Enter text",
        },
        {
          fieldName: "maleEmployees",
          title: "Male",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "femaleEmployees",
          title: "Female",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "other",
          title: "Other",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "notDisclosed",
          title: "Not Disclosed",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "totalEmployees",
          title: "Total Number of Full-time Employees",
          type: "number",
          placeholder: "Total",
        },
      ],
    },
  ];

  const inputData5 = [
    {
      fieldName: "partTimeEmployees",
      fields: [
        {
          fieldName: "region",
          title: "Region",
          type: "text",
          placeholder: "Enter text",
        },
        {
          fieldName: "maleEmployees",
          title: "Male",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "femaleEmployees",
          title: "Female",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "other",
          title: "Other",
          type: "number",
          placeholder: "Enter Number",
        },
        {
          fieldName: "notDisclosed",
          title: "Not Disclosed",
          type: "number",
          // type: "percentage",
          placeholder: "Enter Number",
        },
        {
          fieldName: "totalEmployees",
          title: "Total Number of Part-time Employees",
          type: "number",
          placeholder: "Total",
        },
      ],
    },
  ];

  const [tables, setTables] = React.useState(
    // inputData.map((section) => ({ fieldName: section.fieldName, rows: [{}] }))
    []
  );

  const [tables1, setTables1] = React.useState([]);

  const [tables2, setTables2] = React.useState([]);

  const [tables3, setTables3] = React.useState([]);

  const [tables4, setTables4] = React.useState([]);

  const [tables5, setTables5] = React.useState([]);

  const [tabErrors, setTabErrors] = useState({});
  const [tabErrors1, setTabErrors1] = useState({});
  const [tabErrors2, setTabErrors2] = useState({});
  const [tabErrors3, setTabErrors3] = useState({});
  const [tabErrors4, setTabErrors4] = useState({});
  const [tabErrors5, setTabErrors5] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(
          `${api}/gri/get?type=GeneralDisclosures2021&Id=${id}`
        );
        const data1 =
          response.data.data.GeneralDisclosures2021?.employees || {};

        setData(data1);
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);

        // Set form data
        setFormData({
          dataCompilationMethodology: {
            employeeFiguresReporting:
              data1.dataCompilationMethodology?.employeeFiguresReporting || "",
            employeeDataTimeframe:
              data1.dataCompilationMethodology?.employeeDataTimeframe || "",
          },
          employeeDataContextualInfo: data1.employeeDataContextualInfo || "",
          employeeFluctuations: data1.employeeFluctuations || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    // console.log("fga", formData );
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleNestedInputChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));

    // Remove error for the specific field
    if (value.trim()) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    // Validate sector

    // Validate required fields in the formData
    if (!formData.dataCompilationMethodology.employeeFiguresReporting) {
      newErrors.employeeFiguresReporting = "This field is required";
      formIsValid = false;
    }

    if (!formData.dataCompilationMethodology.employeeDataTimeframe) {
      newErrors.employeeDataTimeframe = "This field is required";
      formIsValid = false;
    }

    if (!formData.employeeDataContextualInfo) {
      newErrors.employeeDataContextualInfo = "This field is required";
      formIsValid = false;
    }

    if (!formData.employeeFluctuations) {
      newErrors.employeeFluctuations = "This field is required";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return;  // Validate form before submission

      // console.log("Form Data Submitted:", formData);

      const isFormValid = validateForm();
      const isTableValid = validateTable(inputData, tables, setTabErrors);
      const isTable1Valid = validateTable(inputData1, tables1, setTabErrors1);
      const isTable2Valid = validateTable(inputData2, tables2, setTabErrors2);
      const isTable3Valid = validateTable(inputData3, tables3, setTabErrors3);
      const isTable4Valid = validateTable(inputData4, tables4, setTabErrors4);
      const isTable5Valid = validateTable(inputData5, tables5, setTabErrors5);

      if (
        !isFormValid ||
        !isTableValid ||
        !isTable1Valid ||
        !isTable2Valid ||
        !isTable3Valid ||
        !isTable4Valid ||
        !isTable5Valid
      ) {
        return;
      }

      let transformedData = restructureData(tables);
      let transformedData1 = restructureData(tables1);
      let transformedData2 = restructureData(tables2);
      let transformedData3 = restructureData(tables3);
      let transformedData4 = restructureData(tables4);
      let transformedData5 = restructureData(tables5);

      transformedData1 = {
        reportNumber: {
          ...transformedData1,
          ...transformedData2,
          ...transformedData3,
          ...transformedData4,
          ...transformedData5,
        },
      };

      console.log(transformedData);

      const payload = {
        type: "GeneralDisclosures2021",
        employees: {
          ...transformedData,

          ...transformedData1,

          ...formData,
        },
        submitted2_7: true,
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        navigate(`/gri/general-disclosure/2-8/${id}`);
      } catch (error) {
        console.error("Error updating data:", error);
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/general-disclosure/2-8/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {/* <SectionHeading text="2-1 Activities, value chain and other business relationships" /> */}
      <p className={styles.main_heading}>2-7 Employees</p>

      {/* Section A */}
      <SectionHeading
        text="a. Provide the total number of employees in the organization, and a breakdown of this total by gender and by region."
        sx={{
          marginBottom: hide ? "-3rem" : "-1.5rem",
          marginTop: hide ? "0rem" : "2rem",
        }}
      />
      <DynamicTable27
        inputData={inputData}
        tables={tables}
        setTables={setTables}
        data={data}
        disabled={disabled}
        errors={tabErrors}
        setErrors={setTabErrors}
        hide={hide}
        disableColumn="totalEmployees"
      />

      {/* Section B */}
      <SectionHeading
        text="b. Report the number of:"
        sx={{ marginBottom: hide ? "-2rem" : "0rem" }}
      />

      <Box sx={{marginLeft:"1rem"}}>
        <SectionHeading
          text="i. Provide the total number of permanent employees in the organization, and a breakdown of this total by gender and by region."
          sx={{ marginBottom: "-1.5rem" ,textIndent:"-0.8rem",}}
        />
        <DynamicTable27
          inputData={inputData1}
          tables={tables1}
          setTables={setTables1}
          data={data?.reportNumber}
          errors={tabErrors1}
          disabled={disabled}
          setErrors={setTabErrors1}
          hide={hide}
          disableColumn="totalEmployees"
        />

        {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
        <SectionHeading
          text="ii. Provide the total number of temporary employees in the organization, and a breakdown of this total by gender and by region."
          sx={{ marginBottom: "-1.5rem" }}
        />
        <DynamicTable27
          inputData={inputData2}
          tables={tables2}
          setTables={setTables2}
          data={data?.reportNumber}
          errors={tabErrors2}
          setErrors={setTabErrors2}
          disabled={disabled}
          hide={hide}
          disableColumn="totalEmployees"
        />

        <SectionHeading
          text="iii. Provide the total number of non-guaranteed hours employees in the organization, and a breakdown of this total by gender and by region."
          sx={{ marginBottom: "-1.5rem",textIndent:"-1.2rem" }}
        />
        <DynamicTable27
          inputData={inputData3}
          tables={tables3}
          setTables={setTables3}
          data={data?.reportNumber}
          errors={tabErrors3}
          setErrors={setTabErrors3}
          disabled={disabled}
          hide={hide}
          disableColumn="totalEmployees"
        />

        <SectionHeading
          text="iv. Provide the total number of full-time employees in the organization, and a breakdown of this total by gender and by region."
          sx={{ marginBottom: "-1.5rem",textIndent:"-1.2rem" }}
        />
        <DynamicTable27
          inputData={inputData4}
          tables={tables4}
          setTables={setTables4}
          data={data?.reportNumber}
          errors={tabErrors4}
          setErrors={setTabErrors4}
          disabled={disabled}
          hide={hide}
          disableColumn="totalEmployees"
        />

        {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
        <SectionHeading
          text="v. Provide the total number of part-time employees in the organization, and a breakdown of this total by gender and by region."
          sx={{ marginBottom: "-1.5rem" }}
        />
        <DynamicTable27
          inputData={inputData5}
          tables={tables5}
          data={data?.reportNumber}
          setTables={setTables5}
          errors={tabErrors5}
          setErrors={setTabErrors5}
          disabled={disabled}
          hide={hide}
          disableColumn="totalEmployees"
        />
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* Section C */}
        <SectionHeading text="c. Describe the methodologies and assumptions used to compile the data, including whether the numbers are reported." />
        <Box sx={{ marginLeft: "1.1rem" }}>
          <SectionHeading
            text="i. Describe if the employee figures reported in headcount (total number of employees) or Full-Time Equivalent (FTE)."
            sx={{ marginTop: "-0.5rem" }}
          />
          <CustomTextField
            value={formData.dataCompilationMethodology.employeeFiguresReporting}
            onChange={(e) =>
              handleNestedInputChange(
                "dataCompilationMethodology",
                "employeeFiguresReporting",
                e.target.value
              )
            }
            error={errors.employeeFiguresReporting}
            helperText={errors.employeeFiguresReporting}
            disabled={disabled}
          />

          <SectionHeading text="ii. Describe if the data represent the number of employees at the end of the reporting period, the average number of employees throughout the period, or another timeframe? " />
          <CustomTextField
            value={formData.dataCompilationMethodology.employeeDataTimeframe}
            onChange={(e) =>
              handleNestedInputChange(
                "dataCompilationMethodology",
                "employeeDataTimeframe",
                e.target.value
              )
            }
            error={errors.employeeDataTimeframe}
            helperText={errors.employeeDataTimeframe}
            disabled={disabled}
          />
        </Box>

        <SectionHeading sx={{textIndent:"-1.1rem"}} text="d. Describe if there's contextual information necessary to understand the data reported under total number of employees and employees by gender breakdown." />
        <CustomTextField
          value={formData.employeeDataContextualInfo}
          onChange={(e) =>
            handleInputChange("employeeDataContextualInfo", e.target.value)
          }
          error={errors.employeeDataContextualInfo}
          helperText={errors.employeeDataContextualInfo}
          disabled={disabled}
        />

        <SectionHeading sx={{textIndent:"-1.1rem"}} text="e. Describe the significant fluctuations in the number of employees during the reporting period and between reporting periods within the organization." />
        <CustomTextField
          value={formData.employeeFluctuations}
          onChange={(e) =>
            handleInputChange("employeeFluctuations", e.target.value)
          }
          error={errors.employeeFluctuations}
          helperText={errors.employeeFluctuations}
          disabled={disabled}
        />

        {/* Submit Button */}

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
             {!griReview ? (
          <Box sx={{ ml: "1rem", width: "98%" }}>
            <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
          </Box>
        ) : (
          <Box textAlign="right" sx={{ mt: 3 }}>
            <Button
              variant="contained"
              sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
              onClick={handleSubmit}
            >
              Save & Continue <EastIcon sx={{ ml: 2 }} />
            </Button>
          </Box>
        )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default Economic27;
